import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { GraphQLClient, GraphQLContext } from '@shane32/graphql';
import { AuthCallback, AuthContainer, AuthLogoutCallback, Authentication } from '@zboxglobal/zboxauth';
import { ApiBaseUrl, AuthBaseUrl, GraphQlBaseUrl, InitializeAuthListener, WebSocketApiBaseUrl } from './globalVariables';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

const auth = new Authentication({
  baseUrl: AuthBaseUrl + "api/jwtauth",
  adminUrl: "",
  clientId: "a15c4f79-f8a9-47a9-a582-29ecec0dd43c",
  callbackUrl: window.location.protocol + "//" + window.location.host + "/auth_callback",
  logoutCallbackUrl: window.location.protocol + "//" + window.location.host + "/auth_logout_callback",
});
const autoLoginPromise = auth.TryAutoLogin();

const client = new GraphQLClient({
  url: ApiBaseUrl + GraphQlBaseUrl,
  webSocketUrl: WebSocketApiBaseUrl + GraphQlBaseUrl,
  transformRequest: (config) => {
    return auth.UpdateToken().then(() => {
      const token = auth.GetAccessToken(); //null if not logged in
      return token
        ? { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } }
        : config;
    });
  },
  generatePayload: () => {
    return auth.UpdateToken().then(() => {
      const token = auth.GetAccessToken(); //null if not logged in
      if (token) {
        return {
          Authorization: "Bearer " + token,
        };
      } else {
        return {};
      }
    });
  },
});

InitializeAuthListener(auth, client);

export const zboxLegalDbFetch = async (path: string, init: RequestInit) => {
  await auth.UpdateToken();
  const token = auth.GetAccessToken(); //null if not logged in
  if (token) {
    init.headers = { ...init.headers, Authorization: `Bearer ${token}` };
  }
  const response = await fetch(ApiBaseUrl + path, init);
  return response;
};

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <GraphQLContext.Provider value={{ client: client }}>
    <AuthContainer client={auth}>
      <BrowserRouter>
        <Switch>
          <Route path="/auth_callback">
            <AuthCallback defaultPath="/">
              <p>Logging in; please wait.</p>
            </AuthCallback>
          </Route>
          <Route path="/auth_logout_callback">
            <AuthLogoutCallback defaultPath="/">
              <p>Logging out; please wait.</p>
            </AuthLogoutCallback>
          </Route>
          <Route>
            <App autoLoginPromise={autoLoginPromise} />
          </Route>
        </Switch>
      </BrowserRouter>
    </AuthContainer>
  </GraphQLContext.Provider>

);
